<template>
    <div>
        <div class=" mb-20">
          <div class="text-center" v-html="$t('ForgotPassWordTitle')"></div>
        </div>
        <div>

          <form
            @submit.prevent="validForm('forgotPasswordForm')"
            data-vv-scope="forgotPasswordForm"
          >
            <vs-input
              v-validate="'required|glot_email'"
              data-vv-validate-on="blur"
              name="email"
              icon-no-border
              :label-placeholder="$t('YourEmail')"
              v-model="email"
              class="w-full"
              />
              <div class="text-danger text-sm">{{ errors.first('forgotPasswordForm.email') }}</div>
              <div class="text-danger text-sm">{{ errMessage }}</div>
          <input class="opacity-0 absolute" type="submit"/>
          </form>

          <div class="mt-10">
            <vs-button tabindex="0" :disabled="!validateForm" @click="validForm('forgotPasswordForm')" class="w-full glot-background-color-1D">{{$t('ResetMyPassword')}}</vs-button>
          </div>
        </div>
    </div>
</template>

<script>

import {getErrorMessage} from '@/i18n/util'
import _throttle from 'lodash/throttle'

export default {
  components: {
  },
  data () {
    return {
      email: '',
      errMessage: ''
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.email !== ''
    }
  },
  methods:{
    resetMyPassword:_throttle(function (vm) {
      vm.$vs.loading({
        background: 'rgba(0, 0, 0, 0.6)'
      })
      vm.errMessage = ''
      const payload = {
        userDetails: {
          email: vm.email
        }
      }
      vm.$store.dispatch('auth/forgotPassword', payload)
        .then(() => { vm.$vs.loading.close() })
        .catch(error => {
          vm.$vs.loading.close()
          vm.errMessage = getErrorMessage(error.messages)
          console.log(error)
          vm.$vs.notify({
            title: 'Error',
            text: getErrorMessage(error.messages),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }, 1000),
    validForm (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          // eslint-disable-next-line
          this.resetMyPassword(this)
        }
      })
    }
  }
}
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
